export const ContainerType = {
  FOLDER: 'FOLDER',
};

export const MediaType = {
  MEDIA: 'Media',
};

export const MODULE_ID = 'media';

export const ROOT = { root: true };

export const SelectedFilter = {
  NONE: 'none',
  TAGS: 'tags',
  UPDATED: 'updated',
  UNREAD: 'unread',
  UNCONFIRMED: 'unconfirmed',
  FAVORITES: 'favorites',
};

export const ChildContainerType = {
  ARTICLE: 'article',
  IMAGE: 'image',
  FOLDER: 'folder',
  VIDEO: 'video',
  PDF: 'pdf',
};

export const DeviceSort = {
  ASC: 'a-z',
  DESC: 'z-a',
};

export const IconMap = {
  FOLDER: 'mdi-folder-outline',
  IMAGE: 'mdi-image-outline',
  VIDEO: 'mdi-file-video-outline',
  AUDIO: 'mdi-file-music-outline',
  PDF: 'mdi-file-pdf-box',
  ARTICLE: 'mdi-file-document-outline',
  HTML: 'mdi-file-code-outline',
};
